import { useActiveMember } from 'hooks';

export function useCanManageCertifications() {
  return useActiveMember().position?.manageCertificates ?? false;
}
